import './App.css';
import React, { useState, useEffect } from 'react';
import { Header } from './Components/Header';
import { Form } from './Components/Form';
import { Notes } from './Components/Notes';
import { Editmodal } from './Components/Editmodal';
import { Footer } from './Components/Footer';
function App() {
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState("");
  const [notes, setNotes] = useState(() => {
    const storedNotes = JSON.parse(localStorage.getItem("notes"));
    return Array.isArray(storedNotes) ? storedNotes : [];
  });
  const [editNote, setEditNote] = useState(null);
  useEffect(() => {
    localStorage.setItem("notes", JSON.stringify(notes));
  }, [notes]);
  return (
    <>
      <Header />
      <Form
        title={title}
        setTitle={setTitle}
        desc={desc}
        setDesc={setDesc}
        notes={notes}
        setNotes={setNotes}
      />
      <Editmodal
        editNote={editNote}
        setEditNote={setEditNote}
        notes={notes}
        setNotes={setNotes}
      />
      <div className="container">
        <div className="row justify-content-center mt-3">
          <div className="col-md-10">
            <h1 className="mb-3">Your Notes</h1>
            {notes.length === 0 ? (
              <div className="card mb-3" style={{border: "2px solid #a7f2faff", borderRadius: "10px", backgroundColor:"#daf3f8ff"}}>
                <div className="card-header">No Notes</div>
                <div className="card-body">
                  <p className="card-text">Start by adding your first note ✨</p>
                </div>
              </div>
            ) : (
              notes.map(element => (
                <Notes
                  key={element.id}
                  element={element}
                  setNotes={setNotes}
                  setEditNote={setEditNote} 
                />
              ))
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default App;
